<template>
  <nav id="navigation">
    <el-row :class="['navigation-container w-full', {'accounts-with-demo-version': hasUserAccountsAndDemoVersion}]">
      <!-- Application logo -->
      <el-col :span="6" class="column left">
        <div id="navAppLogoWrapper" :class="['column']">
          <template v-if="appLogo.type === 'hub'">
            <div class="app-logo">
              <BaseIconSvg
                name="logo:hub-settings"
                @click="handleAppLogoClick"
              />
            </div>
          </template>
          <template v-else>
            <div
              v-if="appLogo.show"
              class="app-logo"
            >
              <img :src="appLogo.url">
            </div>
          </template>
          <div @click="handleAppLogoClick" class="logo-cover"></div>
        </div>

        <!-- Account settings dropdown -->
        <user-account-top-settings></user-account-top-settings>
      </el-col>

      <!-- Help Center Button -->
      <help-center-button :is-logged-out="!isAuthenticated"></help-center-button>

      <!-- Language Selector Icon is visible if Logout -->
      <div v-if="!isAuthenticated" id="languageSelectorOnLogout" :class="{'selected': isLanguageSelectorVisible}" @click="handleUserControlsCommand('selectLanguage')"></div>

      <!-- User controls dropdown -->
      <el-dropdown v-if="isUserControlVisible"
        class="userControls"
        ref="userControls"
        @command="handleUserControlsCommand"
        @visible-change="handleUserControlsVisibleChanged"
        trigger="click">
        <span class="el-dropdown-link">
          <i class="icon"></i><i class="name">{{userControlText}}</i><i class="arrow"></i>
        </span>
        <template #dropdown>
          <el-dropdown-menu class="currentUserActionsPopper py-[10px]!">
            <el-dropdown-item command="userProfileClicked" class="py-[7px]! px-5!">{{$t('label.userProfile')}}</el-dropdown-item>
            <el-dropdown-item command="selectLanguage" class="py-[7px]! px-5!">{{$t('label.language')}} <span class="icon">{{'A文'}}</span></el-dropdown-item>
            <el-dropdown-item command="userSignOutClicked" class="py-[7px]! px-5!">{{$t('label.userSignOut')}}</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </el-row>
  </nav>
</template>

<script src="./navigation.js"></script>
<style lang="scss" src="./navigation.scss"></style>
